import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

class AddBusinessNetworkCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: "",
      userName: "",
      submissionStatus: null,
      currentImageUrl:null,
      submeet: false,
      errors: [],
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
    };
  }

  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    files.forEach((file) => {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
        });
      }
    });

    this.setState({ errors });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submeet: true });

    const { textInput, userName } = this.state;

    if (!textInput || !userName) {
      return; 
    }

    try {
      const formData = new FormData();
      formData.append('image', textInput);
      formData.append('name', userName);

      const response = await axios.post("https://samaj.aasmo.in/api/businessnetworkcategory", formData);

      if (response.status === 201) {
        this.setState({ submissionStatus: 'success', submeet: false });
        setTimeout(() => {
         this.props.history.push("/businessNetworkcategorylist");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };
  

  render() {
    const { textInput, userName, submeet,currentImageUrl, submissionStatus } = this.state;
    const isNameValid = userName.trim().length > 0;

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Add BusinessNetwork Category</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
            <div className="form-group">
                <label>Category Image</label>
                {      console.log(currentImageUrl)}
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!textInput && submeet && "parsley-error"}`}
                  name="textInput"
                  required=""
                  onChange={this.handleChange}
                />
                {!textInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Category Name</label>
                <input
                  className={`form-control ${!isNameValid && submeet && "parsley-error"}`}
                  value={userName}
                  name="userName"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ userName: e.target.value });
                  }}
                />
                {!isNameValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, { notifyGeneralInfo })(AddBusinessNetworkCategory));
